import { Box } from "theme-ui";
import { useSelector } from "react-redux";
import get from "lodash/fp/get";

import { getFormsHaveRequiredValues } from "utils";
import * as styles from "./Progress.styles";

export default function Progress({
  tabs = [],
  selectedTabId,
  userChoiceValues = {},
  ...props
}) {
  const selectedTabIndex = tabs.findIndex(({ id }) => id === selectedTabId);

  const customisationsVisited = useSelector(
    get(["app", "customisationsVisited"])
  );

  return (
    <Box sx={styles.progress} {...props}>
      {tabs.map((customisation, index) => (
        <Box
          key={customisation.id}
          sx={styles.progressItem({
            isSelected: selectedTabIndex === index,
            hasValues: getFormsHaveRequiredValues({
              customisation,
              customisationsVisited,
              userChoiceValues,
            }),
          })}
        />
      ))}
    </Box>
  );
}
